export const IconCalendar = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 10V8H6V11H18V8H16V10H14V8H10V10H8ZM18 13H6V18H18V13ZM6 6H8V4H10V6H14V4H16V6H18H20V8V18V20H18H6H4V18V8V6H6Z"
    />
  </svg>
);
